import { render, staticRenderFns } from "./auditlog.vue?vue&type=template&id=ab4ba514&scoped=true"
import script from "./auditlog.vue?vue&type=script&lang=js"
export * from "./auditlog.vue?vue&type=script&lang=js"
import style0 from "./auditlog.vue?vue&type=style&index=0&id=ab4ba514&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4ba514",
  null
  
)

export default component.exports